import { useState, useEffect } from 'react';
import store from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { formatDate } from '../../common/SharedFunctions';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { GridSettingType, PermissionType } from '@apply/constants';
import { AdminApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { AdminActionsButton } from '../common/Components';
import { adminUserActions } from '@apply/adminStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { formatBoolean } from '../../common/SharedFunctions';

const AdminUsersTable = ({ gridStore, isDeleted = false }) => {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const adminApi = new AdminApi.AdminApi(applicationInsights);
    const dataFunction = (criteria) => {
        criteria.isDeleted = isDeleted;
        return adminApi.getAdminUsersGrid(criteria);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.adminUser);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const dateCellRender = (date) => {
        if (date) {
            return <>{formatDate(date)}</>;
        }
        return null;
    };

    const onActionCellRender = (e) => {
        return (
            <AdminActionsButton
                data={e.data}
                parentId='AdminUsers'
            />
        );
    };

    const onRowDblClick = (e) => {
        dispatch(
            adminUserActions.setAdminUserModal({
                adminUserModal: { isOpen: true, id: e.data.id },
            })
        );
    };

    const onRenderActive = (e) => {
        if (e.value === null || e.value === undefined) {
            return (
                <FontAwesomeIcon
                    icon={faTimes}
                    className='blue-text'
                />
            );
        }
        return formatBoolean(!e.value);
    };

    if (!dataStore) {
        return null;
    }

    return (
        <BfiDataGrid
            gridType={GridSettingType.AdminUsersTable}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            onRowDblClick={onRowDblClick}
        >
            <Column
                dataField='firstName'
                caption='First'
                dataType='string'
                width={150}
            />
            <Column
                dataField='lastName'
                caption='Last'
                dataType='string'
                width={150}
            />
            <Column
                dataField='email'
                caption='Email'
                dataType='string'
            />
            <Column
                dataField='lastActive'
                caption='Last Active'
                cellRender={(e) => dateCellRender(e.data.lastActive)}
                width={120}
            />
            <Column
                dataField='lastPasswordRequested'
                caption='Last Pwd Requested'
                cellRender={(e) => dateCellRender(e.data.lastPasswordResetRequested)}
                width={140}
            />
            <Column
                dataField='lastPasswordResetSent'
                caption='Last Pwd Reset Sent'
                cellRender={(e) => dateCellRender(e.data.lastPasswordResetSent)}
                width={140}
            />
            <Column
                dataField='lastFailedLogin'
                caption='Last Failed Login'
                cellRender={(e) => dateCellRender(e.data.lastFailedLoginAttempt)}
                width={120}
            />
            <Column
                dataField='isLocked'
                caption='Unlocked'
                cellRender={onRenderActive}
                alignment='center'
                width={100}
            />
            <Column
                alignment='center'
                cellRender={(e) => onActionCellRender(e)}
                width={50}
                allowSorting={false}
                allowResizing={false}
                type='actions'
                fixed={true}
                fixedPosition={'right'}
            />
        </BfiDataGrid>
    );
};

export default AdminUsersTable;
